<div class="ced-parc" [class.ced-parc--compacto]="compacto">
  <div class="ced-parc__expr-row">
    <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
      <mat-label>Condição de pagamento</mat-label>
      <input matInput type="text" [(ngModel)]="state.expr" [disabled]="somenteLeitura" (ngModelChange)="normalizarExpressao()"
        (keydown.enter)="gerar()" placeholder="30 60">
    </mat-form-field>
    <button mat-stroked-button type="button" class="btn-secondary" [disabled]="somenteLeitura" (click)="gerar()">
      <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
      gerar parcelas
    </button>
  </div>
  @if (!compacto) {
    <div class="ced-parc__hint">
      Número de parcelas ou prazos. Exemplos: <b class="ced-mono">30 60</b>, <b class="ced-mono">3x</b> ou <b class="ced-mono">15 +2x</b>
    </div>
  }

  <div class="ced-parc__table" [class.ced-parc__table--compacto]="compacto"
    [class.ced-parc__table--sem-forma]="!formasPagamento.length">
    <div class="ced-parc__head">
      <span>Nº</span>
      <span>Dias</span>
      <span>Data</span>
      @if (formasPagamento.length) {
        <span>Forma de pagamento</span>
      }
      <span></span>
    </div>
    @for (p of state.parcelas; track $index) {
      <div class="ced-parc__row">
        <span class="ced-parc__num">{{ $index + 1 }}</span>
        <span class="ced-parc__cell">
          <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
            <input matInput [currencyMask]="diasMask" [(ngModel)]="p.dias" min="0" [disabled]="somenteLeitura"
              (ngModelChange)="atualizarData(p, $event)"
              (blur)="atualizarData(p)">
          </mat-form-field>
        </span>
        <span class="ced-parc__cell">
          <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic" floatLabel="always">
            <input matInput [matDatepicker]="pickerParcela" [min]="dataBase" [(ngModel)]="p.data" [disabled]="somenteLeitura"
              (input)="onDateInput($event)" (dateChange)="atualizarDias(p)"
              (blur)="atualizarDias(p)" placeholder="DD/MM/AAAA">
            <mat-datepicker-toggle matIconSuffix [for]="pickerParcela" [disabled]="somenteLeitura"></mat-datepicker-toggle>
            <mat-datepicker #pickerParcela></mat-datepicker>
          </mat-form-field>
        </span>
        @if (formasPagamento.length) {
          <span class="ced-parc__cell">
            <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
              <mat-select [(ngModel)]="p.idFormaPagamento" [disabled]="somenteLeitura" (ngModelChange)="changed.emit()">
                <mat-option [value]="null">—</mat-option>
                @for (f of formasPagamento; track f.idFormaPagamento) {
                  <mat-option [value]="f.idFormaPagamento">{{ f.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </span>
        }
        <button type="button" mat-icon-button class="btn-remover ced-parc__del" [disabled]="somenteLeitura" (click)="remover($index)" matTooltip="Remover">
          <mat-icon class="material-symbols-outlined">delete</mat-icon>
        </button>
      </div>
    } @empty {
      <app-empty-state
        icon="receipt_long"
        title="Nenhuma parcela."
        subtitle="Digite uma expressão acima e clique em gerar parcelas.">
      </app-empty-state>
    }
    <div class="ced-parc__add-wrap">
      <button mat-stroked-button type="button" class="btn-secondary" [disabled]="somenteLeitura" (click)="adicionar()">
        <mat-icon class="material-symbols-outlined">add_circle</mat-icon>
        adicionar outra parcela
      </button>
    </div>
  </div>
</div>
